import { render, staticRenderFns } from "./Interview_notice.vue?vue&type=template&id=64521557"
import script from "./Interview_notice.vue?vue&type=script&lang=js"
export * from "./Interview_notice.vue?vue&type=script&lang=js"
import style0 from "./Interview_notice.vue?vue&type=style&index=0&id=64521557&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports